module.exports = __webpack_public_path__ + "img/sign-up-logo.8cda32f4.jpeg";